// Images constants
export const LARGE_IMAGE_WIDTH = '260px';
export const BASE_IMAGE_WIDTH = '180px';

// Cards constants
export const CARD_MIN_HEIGHT = '200px';
export const CARD_MIN_HEIGHT_HO = '200px';

// Overlay cards constants
export const OVERLAY_MIN_HEIGHT = '248px';
export const OVERLAY_WIDTH = '320px';

// Price constants
export const PRICE_WIDTH_SMALL = '180px';
export const PRICE_WIDTH_LARGE = '200px';

// breakpoint
export const CARD_MOBILE_BREAKPOINT = '768px';
export const CARD_CONTAINER_QUERY_BREAKPOINT = '788px';
